export const language = {
  en: {
    "Resource Hub": "Resource Hub",
    "Entering Resource Hub": "Entering Resource Hub",
    "Search": "Search",
    "Please Enter A Keyword": "Please Enter A Keyword",
    "Product Knowledge": "Product Knowledge",
    "Sales Knowledge": "Sales Knowledge",
    "Institutional Processes": "Institutional Processes",
    "Released Time": "Released Time",
    "Start Date": "Start Date",
    "End Date": "End Date",
    "by Heat": "by Heat",
    "by Time": "by Time",
    "Category": "Category",
    "Seafood and Aquaculture": "Seafood and Aquaculture",
    "Meat": "Meat",
    "Fruits And Vegetables": "Fruits And Vegetables",
    "Grain Oil & Condiment": "Grain Oil & Condiment",
    "Snacks": "Snacks",
    Drinks: "Drinks",
    "There is no content you searched for":
      "There is no content you searched for",

    "Article Management": "Article Management",
    "Please Enter": "Please Enter",
    "Please Select": "Please Select",
    Title: "Title",
    "Article ID": "Article ID",
    "Article Column": "Article Column",
    "Article Status": "Article Status",
    Unreleased: "Unreleased",
    Released: "Released",
    Author: "Author",
    "Create Article": "Create Article",
    Query: "Query",
    Reset: "Reset",
  
    Edit: "Edit",
    Delete: "Delete",
    "Confirm Delete": "Confirm Delete",
    Cancel: "Cancel",
    Confirm: "Confirm",
    "Please enter title, with a maximum of 200 words":
      "Please enter title, with a maximum of 200 words",
  },
  zh: {
    'Resource Hub': '采购学堂',
    'Entering Resource Hub': '进入采购学堂',
    'Search': '搜索',
    'Please Enter A Keyword': '请输入关键词',
    'Product Knowledge': '产品知识',
    'Sales Knowledge': '销售知识',
    'Institutional Processes': '制度流程',
    'Released Time': '发布时间',
    'Start Date': '开始日期',
    'End Date': '结束日期',
    'by Heat': '按热度排序',
    'by Time': '按时间排序',
    'Category': '所属品类',
    'Seafood and Aquaculture': '海鲜水产',
    'Meat': '肉品',
    'Fruits And Vegetables': '果蔬',
    'Grain Oil & Condiment': '粮油调味',
    'Snacks': '休闲食品',
    'Drinks': '酒水饮料',
    'There is no content you searched for': '没有您搜索的内容',
    
    'Article Management': '文章管理',
    'Please Enter': '请输入',
    'Please Select': '请选择',
    'Title': '文章标题',
    'Article ID': '文章ID',
    'Article Column': '文章栏目',
    'Article Status': '文章状态',
    'Unreleased': '未发布',
    'Released': '已发布',
    'Author': '作者',
    'Create Article': '创建文章',
    'Query': '查询',
    'Reset': '重置',
   
    'Edit': '编辑',
    'Delete': '删除',
    'Confirm Delete': '确认删除',
    'Cancel': '取消',
    'Confirm': '确定',
    'Please enter title, with a maximum of 200 words': '请输入文章标题，最多输入60个字'
   
    
  },
};
